import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=cabc3550&scoped=true"
import script from "./protocol.vue?vue&type=script&lang=js"
export * from "./protocol.vue?vue&type=script&lang=js"
import style0 from "./protocol.vue?vue&type=style&index=0&id=cabc3550&prod&scoped=true&lang=scss"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabc3550",
  null
  
)

export default component.exports